import React, { useState, useRef } from 'react'
import './Login.css'
import axios from 'axios'
import { Baseurl } from '../../Config/Baseurl'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import OTPInput from 'otp-input-react'
import img from '../../assets/images/img.png'
import { BiArrowBack } from 'react-icons/bi'

export const Login = () => {
  const email = useRef()
  toast.configure()
  const navigate = useNavigate()

  // const [err, setErr] = useState(false)
  const [OTP, setOTP] = useState('')
  const [otpValue, setOtpValue] = useState()
  // const [errMsg, setErrMsg] = useState('')
  const [click, setClick] = useState(false)
  const [token, setToken] = useState('')
  const [role, setRole] = useState('')

  // state to store vlaues
  const [data, setData] = useState({
    email: '',
    password: '',
    role: '',
    fname: '',
    lname: '',
  })

  const [message, setMessage] = useState(false)

  // name validation
  const validateName = (name) => {
    if (name.trim().length === 0) {
      toast.error('White or empty space is not allowed.', {
        position: toast.POSITION.TOP_RIGHT,
        toastId: 'spaceErr',
        autoClose: 5000,
      })
      setMessage(true)
    } else {
      setMessage(false)
    }
  }

  // input onchange
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setData({ ...data, [name]: value })
  }

  const getOTP = async (e) => {
    e.preventDefault()
    await axios
      .post(Baseurl.nodeLocal + 'referral/sendOTP', {
        email: data.email,
        name: data.fname + ' ' + data.lname,
      })
      .then((res) => {
        if (res.data.role === 'Interviewer') {
          setToken(res.data.token)
          setRole(res.data.data[0].role)
          localStorage.setItem('user', res.data.data[0].name)
          localStorage.setItem('id', res.data.data[0].uuid)
          localStorage.setItem('email', data.email)
        } else if (res.data.role === 'Employee') {
          setRole(res.data.role)
          localStorage.setItem('user', data.fname)
        }
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'success',
          autoClose: 2000,
        })
        setOtpValue(res.data.otp)
        setTimeout(() => {
          setClick(true)
        }, 2000)
      })
      .catch((err) => {
        // setErr(true)
        // setErrMsg(err.response.data.message)
        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'err',
          autoClose: 8000,
        })
      })
  }
  const verifyOTP = (e) => {
    e.preventDefault()
    if (otpValue === Number(OTP)) {
      toast.success('OTP Verified Successfully!', {
        position: toast.POSITION.TOP_RIGHT,
        toastId: 'OtpSuccess',
        autoClose: 500,
      })
      localStorage.setItem('role', role)
      localStorage.setItem('firstName', data.fname)
      localStorage.setItem('lastName', data.lname)
      localStorage.setItem('email', data.email)
      localStorage.setItem('token', token)
      navigate('/portal')
    } else {
      toast.error("OTP Doesn't Match!", {
        position: toast.POSITION.TOP_RIGHT,
        toastId: 'err1',
        autoClose: 8000,
      })
    }
  }

  return (
    <div
      className="login d-flex justify-content-center align-items-center"
      style={{ height: '100vh' }}
    >
      <div className="container">
        {/* {err && (
          <div
            className="modal fade"
            id="exampleModal"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Alert
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">{errMsg}</div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )} */}
        <div className="card logincard">
          <div className="row g-0">
            <div className="col-md-6">
              <img
                src={img}
                alt="logo"
                style={{ height: '2rem' }}
                className="mt-3"
              />
              <div className="h-100 d-flex justify-content-start align-items-center ">
                <div className="py-4 px-3  w-75">
                  <h4>Sign In</h4>
                  <div className="row">
                    {click ? (
                      <form onSubmit={verifyOTP}>
                        <div className="col-md-12">
                          <div className="mb-2">
                            <h6
                              className="form-text mt-3 mb-3"
                              style={{ fontWeight: 500 }}
                            >
                              Please enter the OTP sent to your inbox.
                            </h6>
                            <OTPInput
                              value={OTP}
                              onChange={setOTP}
                              autoFocus
                              OTPLength={4}
                              otpType="number"
                              disabled={false}
                            />
                          </div>
                        </div>
                        <div className="d-grid gap-2 mt-3">
                          <button
                            className={
                              OTP[0] === undefined ||
                              OTP[1] === undefined ||
                              OTP[2] === undefined ||
                              OTP[3] === undefined
                                ? 'btn btn-primary disabled'
                                : 'btn btn-primary'
                            }
                            type="submit"
                          >
                            Sign In
                          </button>
                          <BiArrowBack
                            className="mt-3"
                            onClick={() => setClick(false)}
                            style={{
                              cursor: 'pointer',
                              height: 20,
                              width: 20,
                              color: 'black',
                            }}
                          />
                        </div>
                      </form>
                    ) : (
                      <form onSubmit={getOTP}>
                        <h6
                          className="form-text mt-3 mb-3 mx-1"
                          style={{ fontWeight: 500 }}
                        >
                          Enter the email address associated with your account.
                        </h6>
                        <div className="col-md-12">
                          <div className="mb-2">
                            <input
                              type="email"
                              className="form-control"
                              id="exampleFormControlInput1"
                              placeholder="Email"
                              name="email"
                              onChange={handleChange}
                              value={data.email}
                              ref={email}
                              required
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div class="input-group">
                            <input
                              type="text"
                              className="form-control col-md-6"
                              id="exampleFormControlInput1"
                              placeholder="First Name"
                              name="fname"
                              onChange={handleChange}
                              value={data.fname}
                              onBlur={() => {
                                validateName(data.fname)
                              }}
                              required
                            />
                            <input
                              type="text"
                              className="form-control col-md-6"
                              id="exampleFormControlInput1"
                              placeholder="Last Name"
                              name="lname"
                              onChange={handleChange}
                              value={data.lname}
                              onBlur={() => {
                                validateName(data.lname)
                              }}
                              required
                            />
                          </div>
                        </div>
                        <div className="mt-2 d-flex justify-content-between w-100">
                          <button
                            className={
                              message ||
                              data.email === '' ||
                              data.fname === '' ||
                              data.lname === ''
                                ? 'btn btn-primary disabled'
                                : 'btn btn-primary'
                            }
                            type={
                              message ||
                              data.email === '' ||
                              data.fname === '' ||
                              data.lname === ''
                                ? 'button'
                                : 'submit'
                            }
                          >
                            Send OTP
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="right-side-content">
                <div className="content d-flex flex-column">
                  <h1>
                    Welcome <br />
                    To Intranet.
                  </h1>
                </div>
                <div className="right-side">
                  <span></span> <span></span> <span></span> <span></span>
                  <span></span> <span></span> <span></span> <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="parallelogram">
          <span></span> <span></span> <span></span>
        </div>
      </div>
    </div>
  )
}
